import invert from "lodash/invert";
import PropTypes from "prop-types";
import React, { Component } from "react";

import Avatar from "./Avatar";
import Badge from "./Badge";
import BadgeType from "../../constants/ChatBadgeTypes";
import { createSanitizedMarkup } from "../../utils/Utils";

class Author extends Component {
    get authorType() {
        /*
         * Priority is:
         * CERTIFIED overrides ELITE;
         * OFFICIAL overrides CERTIFIED;
         */
        const badgeTypeToAuthorTypeMapping = invert({
            [BadgeType.ELITE]: this.props.isElite,
            [BadgeType.CERTIFIED]: this.props.isCertified,
            [BadgeType.OFFICIAL]: this.props.isOfficial,
        });

        return badgeTypeToAuthorTypeMapping.true;
    }

    render() {
        const { authorTitle, avatarSrc, avatarSize, name, reputation } = this.props;
        const badgeLabelMapping = {
            [BadgeType.CERTIFIED]: i18n.t("rtm.text.badge_certified"),
            [BadgeType.ELITE]: i18n.t("rtm.text.badge_elite"),
            [BadgeType.OFFICIAL]: i18n.t("rtm.text.badge_official"),
        };

        let helpfulnessText = null;
        if (reputation) {
            const { helpfulnessScore } = reputation;

            helpfulnessText =
                parseFloat(helpfulnessScore) > 0
                    ? i18n.t("rtm.text.helpful_score", {
                          helpfulnessScore: parseInt(helpfulnessScore * 100, 10),
                      })
                    : "";
        }
        const size = parseInt(avatarSize, 10);

        return (
            <div className="author">
                <Avatar name={name} src={avatarSrc} size={size} />
                <div className="profile">
                    <div className="name-wrapper">
                        <div className="name" dangerouslySetInnerHTML={createSanitizedMarkup(name)} />
                        {this.authorType ? (
                            <Badge
                                isCollapsed
                                label={badgeLabelMapping[this.authorType]}
                                type={BadgeType[this.authorType]}
                            />
                        ) : null}
                    </div>
                    {!authorTitle && reputation && reputation.numberOfAnswers > 0 && (
                        <div className="reputation">
                            {reputation.numberOfAnswers > 0 && !authorTitle && (
                                <span>
                                    {i18n.t("rtm.text.reputation", {
                                        numberOfAnswers: reputation.numberOfAnswers,
                                        helpfulnessText,
                                    })}
                                </span>
                            )}
                        </div>
                    )}
                    {authorTitle && (
                        <div className="reputation">
                            <span>{authorTitle}</span>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

Author.defaultProps = {
    authorTitle: "",
    avatarSize: 30,
    isCertified: false,
    isElite: false,
    isOfficial: false,
    reputation: undefined,
};

Author.propTypes = {
    authorTitle: PropTypes.string,
    avatarSrc: PropTypes.string.isRequired,
    avatarSize: PropTypes.number,
    isCertified: PropTypes.bool,
    isElite: PropTypes.bool,
    isOfficial: PropTypes.bool,
    name: PropTypes.string.isRequired,
    reputation: PropTypes.shape({
        helpfulnessScore: PropTypes.number.isRequired,
        numberOfAnswers: PropTypes.number.isRequired,
    }),
};

export default Author;
